import { Button } from "@/components/ui/button";
import { DietTypeCard } from "@/components/diet/DietTypeCard";
import { useDietContext } from "@/contexts/DietContext";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const DietSelectionStep = ({ availableDiets }) => {
    const { t } = useTranslation();
    const { formData, setFormData, setStep } = useDietContext();
    const { user, setSelectedDietType, selectedDietType } = useAuth();
    const navigate = useNavigate();
    const handleDietSelect = (dietId: string) => {
        setFormData((prev) => ({ ...prev, type: dietId }));
    };

    useEffect(() => {
        if (selectedDietType) {
            setFormData((prev) => ({ ...prev, type: selectedDietType }));
        }
    }, [selectedDietType, setFormData]);

    const onNextStep = () => {
        if (!user) {
            setSelectedDietType(formData.type);
            navigate("/signup");
            return;
        }
        setStep((prev) => prev + 1);
    };

    return (
        <div className="space-y-6">
            <div className="text-center mb-12">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">{t("buildDiet.dietSelection.title")}</h1>
                <p className="text-xl text-gray-600">{t("buildDiet.dietSelection.description")}</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                {availableDiets.map((diet) => (
                    <DietTypeCard key={diet.id} diet={diet} isSelected={formData.type === diet.id} onSelect={() => handleDietSelect(diet.id)} />
                ))}
            </div>

            <div>&nbsp;</div>
            <div className="max-w-2xl mx-auto flex justify-end pt-4 border-t border-gray-800 ">
                <Button onClick={onNextStep} disabled={!formData.type} size="lg">
                    {t("buildDiet.next")}
                </Button>
            </div>
        </div>
    );
};
